import React from 'react';
import MenuItem from './MenuItem';

const Menu = ({
  items,
  activeTab,
  onTabClick
}) => {
  return (
    <div className="bg-gray-100 dark:bg-gray-700 rounded-lg overflow-hidden">
      {items.map((item) => (
        <MenuItem
          key={item.id}
          label={item.label}
          icon={item.icon}
          isActive={activeTab === item.id}
          onClick={() => onTabClick(item.id)}
          badge={item.badge}
        />
      ))}
    </div>
  );
};

export default Menu;